<script setup>
import { onMounted } from 'vue';
import setTooltip from '../assets/js/tooltip';
import { useI18n } from 'vue-i18n';

defineProps({
    name: {
        type: String,
        required: true
    },
    id: {
        type: String,
        default: "",
    },
    icon: {
        type: String,
        default: "",
    },
    color_icon: {
        type: String,
        default: "",
    },
    subs: {
        type: Object
    },
    edit: {
        type: Object
    },
    darkmode: {
        type: Boolean,
        default: false
    }
});

const { t } = useI18n();

onMounted(() => {
  setTooltip
});

const emit = defineEmits(['edit', 'archive', 'delete']);

const editCategory = (data) => {
    emit('edit', data);
}

const archiveCategory = (category, archive) => {

    emit('archive', category, archive);
}

const deleteCategory = (category) => {

    emit('delete', category);
}

const getContrastYIQ = (hexcolor) => {
    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}

</script>

<template>
    <div class="col-12">

        <div class="row align-items-center row-categories">

            <div class="col-2 col-lg-1 ms-0 ms-lg-3 text-center">
                <div class="text-center shadow icon icon-shape align-self-center rounded-5 ms-2 me-3" :style="'background-color: '+color_icon">
                    
                    <i :class="'fal ' + icon +' row-categories-icons' " :style="'color:'+getContrastYIQ(color_icon)"></i>
                </div>
        
            </div>
            <div class="col-6 col-lg-7">
                <h6 class="mb-0 ms-3 ms-lg-0 text-md">{{ name }}</h6>
            </div>
            <div class="col-4 col-lg-3 text-end">
                <a 
                    v-if="edit.archived == 'No'" 
                    @click="editCategory(edit)" 
                    data-bs-toggle="modal" 
                    data-bs-target="#addCategoryModal" 
                    class="me-3 cursor-pointer"
                >
                    <i 
                        class="fal fa-pencil row-categories-icons-actions"
                        :class="darkmode ? 'text-white-50' : 'text-black-50'"
                        v-tooltip="{
                                    content:t('message.global.edit'),
                                    distance: 15
                                }"
                    >
                    </i>
                </a>
                <a v-if="edit.archived == 'No'" @click="archiveCategory(edit, 'Yes')" class="me-3 cursor-pointer">
                    <i 
                        class="fal fa-inbox-in row-categories-icons-actions"
                        :class="darkmode ? 'text-white-50' : 'text-black-50'"
                        v-tooltip="{
                                    content:t('message.global.archive'),
                                    distance: 15
                                }"
                    >
                    </i>
                </a>
                <a v-if="edit.archived == 'Yes'" @click="archiveCategory(edit, 'No')" class="me-3 cursor-pointer">
                    <i 
                        class="fal fa-inbox-out row-categories-icons-actions"
                        :class="darkmode ? 'text-white-50' : 'text-black-50'"
                        v-tooltip="{
                                    content:t('message.global.desarchive'),
                                    distance: 15
                                }"
                    >
                    </i>
                </a>
                <a  v-if="edit.archived == 'Yes'" @click="deleteCategory(edit)" class="me-3 cursor-pointer">
                            <i 
                                class="fal fa-trash text-danger row-categories-icons-actions"
                                v-tooltip="{
                                    content:t('message.global.delete'),
                                    distance: 15
                                }"
                            >
                            </i>
                        </a>
            </div>

        </div>

        <div 
            v-for="(subcategory, index) in subs" :key="index"
            class="row align-items-center row-categories"
        >

            <div class="col-12 col-lg-11 ms-auto">

                <div class="row align-items-center">

                    <div class="col col-lg-2 ms-0 ms-lg-3 text-center">
                        <i class="fal fa-level-up fa-rotate-90 me-3 me-lg-5"></i>
                        <i :class="'fal ' + subcategory.icon +' row-categories-icons' " :style="'color:'+subcategory.color"></i>
                    </div>
                    <div class="col col-lg-4">
                        <h6 class="mb-0 text-md">{{ subcategory.name }}</h6>
                    </div>
                    <div class="col-4 text-end">
                        <a 
                            v-if="subcategory.archived == 'No'" 
                            @click="editCategory(subcategory)" 
                            data-bs-toggle="modal" 
                            data-bs-target="#addCategoryModal" 
                            class="me-3 cursor-pointer"
                        >
                            <i 
                                class="fal fa-pencil row-categories-icons-actions"
                                :class="darkmode ? 'text-white-50' : 'text-black-50'"
                                v-tooltip="{
                                    content:'Editar',
                                    distance: 15
                                }"
                                
                            >
                            </i>
                        </a>
                        <a  v-if="subcategory.archived == 'No'" @click="archiveCategory(subcategory, 'Yes')" class="me-3 cursor-pointer">
                            <i 
                                class="fal fa-inbox-in row-categories-icons-actions"
                                :class="darkmode ? 'text-white-50' : 'text-black-50'"
                                v-tooltip="{
                                    content:'Arquivar',
                                    distance: 15
                                }"
                            >
                            </i>
                        </a>
                        <a  v-if="subcategory.archived == 'Yes'" @click="archiveCategory(subcategory, 'No')" class="me-3 cursor-pointer">
                            <i 
                                class="fal fa-inbox-out row-categories-icons-actions"
                                :class="darkmode ? 'text-white-50' : 'text-black-50'"
                                v-tooltip="{
                                    content:'Desarquivar',
                                    distance: 15
                                }"
                            >
                            </i>
                        </a>
                        <a  v-if="subcategory.archived == 'Yes'" @click="deleteCategory(subcategory)" class="me-3 cursor-pointer">
                            <i 
                                class="fal fa-trash text-danger row-categories-icons-actions"
                                v-tooltip="{
                                    content:'Excluir',
                                    distance: 15
                                }"
                            >
                            </i>
                        </a>
                    </div>

                </div>

            </div>

        </div>
        

    </div>
</template>

<style>
    .row-categories{
        height: 70px;
    }

    .row-categories{
        border-bottom: solid 1px #dee2e6;
    }

    .row-categories-icons{
        font-size: 20px;
    }

    .row-categories-icons-actions{
        font-size: 20px;
    }

    
</style>